import { render, staticRenderFns } from "./RecepcionEquipos.vue?vue&type=template&id=fa4782da&"
import script from "./RecepcionEquipos.vue?vue&type=script&lang=ts&"
export * from "./RecepcionEquipos.vue?vue&type=script&lang=ts&"
import style0 from "./RecepcionEquipos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fa4782da', component.options)
    } else {
      api.reload('fa4782da', component.options)
    }
    module.hot.accept("./RecepcionEquipos.vue?vue&type=template&id=fa4782da&", function () {
      api.rerender('fa4782da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/RecepcionEquipos/RecepcionEquipos.vue"
export default component.exports